import { createContext, type ReactNode } from 'react'
import type { Usuario } from '@/models'

export interface AuthProviderProps {
  children: ReactNode
}

export interface AuthState {
  id?: string
  nome?: string
  token?: string | null
  login?: string
  pode_assinar?: boolean
  is_admin?: boolean
  email?: string
  permissao_para_baixar_arquivos?: boolean
  permissao_para_compartilhar_arquivos?: boolean
  permissao_para_enviar_processos_ao_papel_zero?: boolean
  permissao_para_alterar_responsavel_do_processo?: boolean
  permissao_para_parametrizar_campos_da_integracao?: boolean
}

export interface AuthContextData extends AuthState {
  carregandoSistema: boolean
  estaAutenticado: boolean
  logar(): Promise<void>
  deslogar(): Promise<void>
  atualizarDadosUsuarioLogado(dados: Partial<Usuario>): void
}

export const AuthContext = createContext<AuthContextData>({} as AuthContextData)
